<template>
  <b-modal :visible="show" @hidden="$emit('update:show', false)" @ok="onSave" title="Trainer" ok-title="Save" size="lg" hide-footer>
    <b-form @submit.prevent="onSave">
      <b-form-group label="Name" label-for="trainer_name"><b-form-input id="trainer_name" v-model.trim="form.name" required/></b-form-group>
      <b-form-group label="Email"><b-form-input type="email" v-model.trim="form.email"/></b-form-group>
      <b-form-group label="Phone"><b-form-input v-model.trim="form.phone"/></b-form-group>
      <b-form-group label="Bio"><b-form-textarea v-model="form.bio" rows="3"/></b-form-group>
      <div class="d-flex justify-content-end">
        <b-button variant="outline-secondary" class="mr-50" @click="$emit('update:show', false)">Cancel</b-button>
        <b-button variant="primary" type="submit">Save</b-button>
      </div>
    </b-form>
  </b-modal>
</template>
<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BButton } from 'bootstrap-vue';
import store from '@/store';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
export default {
  components: { BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BButton },
  props: { show: { type:Boolean, default:false }, editId: { type:[Number, String, null], default:null } },
  data(){ return { form: { name:'', email:'', phone:'', bio:'' } }; },
  watch:{ show(val){ if(val){ this.init(); } } },
  methods:{
    init(){ if(this.editId){ store.dispatch('settings/getTrainerById', { id:this.editId }).then(res=>{ this.form = { name: res.data.name || '', email: res.data.email || '', phone: res.data.phone || '', bio: res.data.bio || '' }; }); } else { this.form = { name:'', email:'', phone:'', bio:'' }; } },
    onSave(){ const action = this.editId ? 'updateTrainer' : 'saveTrainer'; const payload = this.editId ? { id:this.editId, ...this.form } : this.form; store.dispatch(`settings/${action}`, payload).then(()=>{ this.$toast({ component: ToastificationContent, props: { title: this.editId ? 'Trainer updated' : 'Trainer created', icon:'ThumbsUpIcon', variant:'success' } }); this.$emit('saved'); }).catch(()=>{ this.$toast({ component: ToastificationContent, props: { title:'Save failed', icon:'AlertTriangleIcon', variant:'danger' } }); }); }
  }
}
</script>
